// 模板 20：信息安全与运维服务平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '企业信息安全与运维一体化平台',
        content:
          '从安全防护到运维监控，帮助企业构建稳定可靠的 IT 环境。'
      },
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '安全可视化运营中心',
        content:
          '通过可视化大屏与告警联动，让安全运维更加直观高效。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '安全与运维数据平台',
      subtitle: '/ SecOps Data Platform',
      paragraphs: [
        '平台汇聚日志、流量与资产等多类数据，为安全分析与运维监控提供基础。',
        '支持多维度分析与告警配置，帮助企业及时发现风险与故障。'
      ],
      buttonText: '预约安全评估'
    },
    contact: {
      title: '守护企业数字资产安全',
      subTitle: '让安全与可用性成为企业的核心能力',
      buttonText: '联系安全顾问'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '安维信息科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__专注信息安全与 IT 运维领域，为企业提供平台与服务一体化解决方案。',
      '我们相信安全与稳定是数字化业务的基础。'
    ]
  },
  news: [
    {
      id: 'SEC01',
      title: '安全运营中心建设项目交付',
      introduce:
        '为某集团搭建统一安全运营中心，实现多系统安全事件集中管理。',
      date: '10-03',
      year: '2024'
    },
    {
      id: 'SEC02',
      title: '日志审计与合规模块升级',
      introduce:
        '支持更多合规规范的审计报表模板，提高企业合规效率。',
      date: '06-21',
      year: '2024'
    },
    {
      id: 'SEC03',
      title: '召开年度安全技术沙龙',
      introduce:
        '邀请多位安全专家分享攻防实践与防护经验。',
      date: '12-15',
      year: '2023'
    },
    {
      id: 'SEC04',
      title: '运维监控平台新增 AI 诊断能力',
      introduce:
        '通过模型分析历史告警数据，辅助识别潜在风险点。',
      date: '08-09',
      year: '2023'
    },
    {
      id: 'SEC05',
      title: '通过多项安全认证',
      introduce:
        '公司平台与服务通过多项安全与质量管理体系认证。',
      date: '04-01',
      year: '2023'
    }
  ],
  software: {
    smartTown: {
      title: '统一安全管理平台',
      sections: [
        {
          heading: '1. 资产与风险管理',
          content:
            '梳理企业 IT 资产与风险点，为防护策略提供依据。'
        },
        {
          heading: '2. 漏洞与补丁管理',
          content:
            '统一管理漏洞扫描结果与补丁下发情况，降低暴露面。'
        },
        {
          heading: '3. 安全事件响应',
          content:
            '支持安全事件工单化处理，记录完整处置过程。'
        },
        {
          heading: '4. 合规与审计',
          content:
            '提供多种合规场景的报表与审计视图。'
        }
      ]
    },
    bigData: {
      title: '运维监控与日志分析系统',
      sections: [
        {
          heading: '1. 指标监控',
          desc:
            '监控主机、网络与中间件等多类指标，及时发现异常。'
        },
        {
          heading: '2. 日志集中管理',
          desc:
            '集中采集与存储多源日志，支持检索与分析。'
        },
        {
          heading: '3. 告警规则与通知',
          desc:
            '配置多种告警规则与通知渠道，确保问题被及时响应。'
        },
        {
          heading: '4. 变更与发布记录',
          desc:
            '记录系统变更与发布情况，便于问题追溯。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '安全评估与渗透测试',
      engTitle: 'Security Assessment',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '安全运营中心建设',
      engTitle: 'SOC Build',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '运维监控平台实施',
      engTitle: 'Monitoring Delivery',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '托管安全与运维服务',
      engTitle: 'Managed SecOps',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '安全运维工程师',
    responsibilities: [
      '负责企业客户安全与运维平台日常运维；',
      '分析与处理安全与运维告警事件；',
      '参与安全加固与故障优化工作。'
    ],
    requirements: [
      '了解常见信息安全与运维技术，有相关经验优先；',
      '具备良好的分析与问题解决能力；',
      '对安全与稳定性有强烈责任感。'
    ],
    buttonText: '加入安全团队'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-20.js